<template>

    <custom-button
        type="dark"
        :size="btnSize"
        :name="btnTitle"
        icon="icon-ak-export"
        @click.native="doExport()"
        :class="{ 'is-disabled': isDisabled }">

        <!-- MODAL WINDOW -->
        <modal
            width="460"
            :title="$t(modalTitle)"
            transition="fadeDown"
            cancel-text="Abbrechen"
            :show-ok="false"
            :backdrop-closable="false"
            :is-show="showModal"
            @close="showModal=false"
            class="vcenter">

            <div class="has-text-centered">

                <template v-if="downloadLink == '' && modalErrorMsg == false">
                    <loading-indicator-small></loading-indicator-small>
                </template>

                <template v-else class="has-text-centered">

                    <template v-if="modalErrorMsg == false">
                        <a :href="downloadLink" download class="button is-success" @click.stop="showModal=false">
                            <span class="icon is-small"><i class="fa fa-download"></i></span>
                            &nbsp;<span>DOWNLOAD</span>
                        </a>
                    </template>

                    <template v-else>
                        {{ modalErrorMsg }}
                    </template>

                </template>

            </div>

        </modal>

    </custom-button>


</template>


<script>

export default {

    props: {
        export: {
            type: String,
            default: ''
        },
        modalTitle: {
            type: String,
            default: 'EXPORT'
        },
        btnTitle: {
            type: String,
            default: 'EXPORT'
        },
        btnSize: {
            type: String,
            default: 'isLarge'
        },
        exportId: {
            type: [Number,String],
            default: null
        },
        isDisabled: {
            type: Boolean,
            default: false
        },
        downloadOnly: {
            type: Boolean,
            default: false
        }
    },

    data () {
      return {
          showModal: false,
          downloadLink: '',
          modalErrorMsg: false
      }
    },

    created() {

    },

    methods: {

      doExport() {

          this.showModal = true;
          this.downloadLink = "";

          // let self = this;
          let urlPart = "";

          var urls = {
            'successControl': 'site/' + this.exportId + '/performanceDocument?link=1',
            'pharmacies': 'siteCatalog/exportList?output=xlsx&link=1&filename=apotheken',
            'pharmaciesCustomizations': 'siteCatalog/customizationsExportList?output=xlsx&link=1&filename=verrechnung-mutationen&catalog='+this.catalogId,
            'catalog': 'catalog/export?catalog='+this.catalogId+'&output=xlsx&link=1&filename=seitenspiegel',
            'equipments': 'equipment/export?output=xlsx&link=1',
            'equipmentCatalog': 'equipmentCatalog/1/export?output=xlsx&link=1&filename=geraetekatalog',
            'products': 'product/exportList?output=xlsx&link=1&active=1&filename=aktive_produkte',
            'newsletterRecipients': 'newsletter/exportSubscribers?site='+this.exportId+'&output=xlsx&filename=newsletter-empfänger&link=1',
            'complatNewsletterRecipients': 'newsletter/exportSubscribersByChannel?channel='+this.exportId+'&output=xlsx&filename=newsletter-empfänger&link=1',
            'articleVariant': 'articleVariant/'+this.exportId+'/render?link=1',
            'equipmentCatalogPage': 'equipmentCatalogPage/'+this.exportId+'/render?link=1',
            'newsletter': 'siteNewsletter/' + this.exportId + '/zip',
            'newsletterSubscribers': 'site/' + this.exportId + '/newsletterSubscribers',
          };


          if(this.downloadOnly) {
              this.downloadLink = this.$config.api + urls[this.export];
              return;
          }

          if (urls[this.export]) {

    				this.entityGet(urls[this.export])
    					.then(res => {

                if(this.downloadOnly) {

                    this.downloadLink = "";

                } else {

                  if(this.export == 'successControl') {
                    this.downloadLink = this.$config.assets + 'sitePerformanceDocument/' + res.site.filename;
                  } else if(this.export == 'articleVariant') {
                    this.downloadLink = this.$config.assets + res.articleVariant.dir + '/' + res.articleVariant.filename;
                  } else if(this.export == 'equipmentCatalogPage') {
                    this.downloadLink = res.path;
                  } else if(this.export == 'newsletter') {
                    this.downloadLink = res.url;
                  } else if(this.export == 'newsletterSubscribers') {
                      this.downloadLink = res;
                  } else {
                      this.downloadLink = this.$config.cdnHost + res.url;
                  }

              }

            }).catch(error => {
                this.modalErrorMsg = "Beim Erstellen des Downloadlinks trat ein Fehler auf: " + error;
            });

          } else {
            this.modalErrorMsg = "Dieser Export existiert nicht!";
          }

      }

    }
}

</script>

<style lang="scss" scoped>

    .modal {
        ::v-deep .modal-card {
            min-height: 50px;
        }
    }

</style>
